<!--
    描述：基础管理 --- 假期管理
    时间：2021-04-15
    Created by 王帅
-->
<template>
    <div class="operation-layout">
        <div class="operation-header">
            <div class="title">假期列表</div>
            <div class="btnGroups">
                <el-button class="btn-success" size="small" @click="handleTool('add')"
                    >新增</el-button
                >
            </div>
        </div>

        <!-- 表格内容 -->
        <div class="operation-container w-table-layout w-table-page">
            <div class="w-table-content">
                <vxe-table
                    :data="tableObj.tableData"
                    border
                    resizable
                    height="100%"
                    size="small"
                    highlight-current-row
                    highlight-hover-row
                    :loading="tableObj.loading"
                    show-overflow="tooltip"
                    show-header-overflow="tooltip"
                    align="center"
                >
                    <vxe-table-column
                        type="seq"
                        title="序号"
                        width="80"
                        align="center"
                    ></vxe-table-column>
                    <vxe-table-column
                        field="holiday"
                        title="日期"
                        show-overflow
                        min-width="180"
                    >
                        <template #default="{ row, rowIndex }">
                            <div>{{ row.holiday.slice(0, 10) }}</div>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column
                        field="typeName"
                        title="类型"
                        align="center"
                        min-width="150"
                    ></vxe-table-column>
                    <vxe-table-column title="操作" width="120">
                        <template v-slot="{ row }">
                            <el-button
                                type="danger"
                                size="small"
                                round
                                plain
                                class="table-btn"
                                icon="el-icon-delete"
                                @click="handleTool('delete', row)"
                                >删除
                            </el-button>
                        </template>
                    </vxe-table-column>
                </vxe-table>
            </div>
            <div class="w-table-footer">
                <vxe-pager
                    size="mini"
                    :current-page="tableObj.currentPage"
                    :page-size="tableObj.pageSize"
                    :total="tableObj.totalResult"
                    class="text-center"
                    :page-sizes="[10, 20, 50, 100, { label: '全部数据', value: -1 }]"
                    :layouts="[
                        'Total',
                        'Sizes',
                        'PrevPage',
                        'JumpNumber',
                        'NextPage',
                        ,
                        'FullJump',
                    ]"
                    @page-change="handlePageChange"
                >
                </vxe-pager>
            </div>
        </div>

        <!-- 新增弹窗 -->
        <el-dialog
            :title="dialogObj.title"
            :visible.sync="dialogObj.visible"
            :width="dialogObj.width"
            :close-on-click-modal="false"
            center
            @closed="handleClosed"
        >
            <el-form
                :model="dayForm"
                ref="dayForm"
                v-if="dialogObj.visible"
                :rules="formRules"
                :show-message="false"
                label-width="80px"
            >
                <el-form-item label="日期类型" prop="type">
                    <el-select v-model="dayForm.type" clearable>
                        <el-option
                            v-for="(item, index) in jqlx"
                            :key="'类型' + index"
                            :label="item.sname"
                            :value="item.value"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="选择日期" prop="holiday">
                    <el-date-picker
                        v-model="dayForm.holiday"
                        type="date"
                        clearable
                        value-format="yyyy-MM-dd"
                        placeholder="选择日期"
                    >
                    </el-date-picker>
                </el-form-item>
            </el-form>

            <!-- footer 组件 -->
            <div slot="footer" class="pdb10 text-center">
                <el-button size="small" class="btn" @click="dialogObj.visible = false"
                    >取 消
                </el-button>
                <el-button
                    type="primary"
                    size="small"
                    class="btn btn-blue"
                    @click="doSubmit"
                    >确 定
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import * as Api from "api/modules/holiday.js";
import { mapState } from "vuex";
export default {
    name: "HolidayIndex",
    data() {
        return {
            tableObj: {
                tableData: [],
                currentPage: 1,
                pageSize: 10,
                totalResult: 0,
                loading: false,
            },
            dialogObj: {
                title: "新增",
                visible: false,
                width: "500px",
            },
            // 新增假期弹窗表单
            dayForm: {
                type: "",
                holiday: "",
            },
            formRules: {
                type: [{ required: true, trigger: "change" }],
                holiday: [{ required: true, trigger: "change" }],
            },
        };
    },
    created() {
        this.getTableList();
    },
    methods: {
        // 获取表格数据
        getTableList(page) {
            let curPage = page ? page : this.tableObj.currentPage;
            let params = {
                current: curPage,
                size: this.tableObj.pageSize,
            };
            Api.getHolidayList(params)
                .then((res) => {
                    this.tableObj.tableData = res.data.records;
                    this.tableObj.totalResult = parseInt(res.data.total);
                })
                .catch((err) => {});
        },

        // 操作事件
        handleTool(type, row) {
            switch (type) {
                case "add":
                    this.dialogObj.visible = true;
                    break;
                case "delete":
                    this.$confirm("确认删除该假期吗?", "提示", {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                        .then(() => {
                            // deleteRule({ id: row.id })
                            Api.deleteHoliday({ id: row.id })
                                .then((res) => {
                                    this.$message.success("删除成功！");
                                    this.getTableList(1);
                                })
                                .catch((err) => {});
                        })
                        .catch(() => {});
                    break;
            }
        },

        // 确认添加/编辑
        doSubmit() {
            let params = Object.assign({}, this.dayForm);
            this.$refs.dayForm.validate((valid) => {
                if (valid) {
                    // saveRules(params)
                    Api.saveHoliday(params)
                        .then((res) => {
                            this.$message.success('保存成功！');
                            this.handleClosed();
                        })
                        .catch((err) => {});
                } else {
                    this.$message.warning("请填写必填项");
                }
            });
        },

        // 切换页码
        handlePageChange({ currentPage, pageSize }) {
            this.currentPage = currentPage;
            this.pageSize = pageSize;

            this.getTableList();
        },

        // 关闭弹窗
        handleClosed() {
            this.dialogObj.visible = false
            this.dayForm.id = "";
            this.dayForm.type = "";
            this.dayForm.holiday = "";

            this.getTableList(1);
        },
    },
    computed: {
        ...mapState("dict", {
            jqlx: (state) => state.projectDict.jqlx || [],
        }),
    },
};
</script>

<style scoped lang="less"></style>
